import { makeStyles } from "@material-ui/core/styles";
import {
  calculateFontSize,
  setFontColorOnBg,
} from "../../CustomHooks/useThemeHook";

const useStyles = makeStyles((theme) => ({
  appBar: {
    top: "auto",
    bottom: 0,
    height: 0,
  },
  btnCon: {
    position: "absolute",
    textTransform: "none",
    zIndex: 1,
    bottom: 10,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  btnScrollCon: {
    position: "absolute",
    textTransform: "none",
    zIndex: 1,
    bottom: 10,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  btn: {
    color: 'white',
    border: '1px solid black',
    margin: '0px 0px 0px 10px',
    fontSize: 14,
    borderRadius: 10,
    textTransform: 'none',
    textDecoration: 'none',
    backgroundColor: '#000',
  },
  spclBtn: {
    color: 'white',
    width: '320px',
    border: '1px solid black',
    margin: '0 1rem',
    padding: '10.5px 16px',
    fontSize: 12,
    lineHeight: '18.79px',
    borderRadius: 10,
    textTransform: 'capitalize',
    backgroundColor: '#000',
  },
  specialBtn: {
    margin: "0 1rem",
    width: "70px",
    color: setFontColorOnBg(theme?.palette?.button?.buttonColor || "#000000"),
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    borderRadius:
      theme?.palette?.button?.borderRadius || theme?.shape?.borderRadius,
    padding: theme.spacing(1.05, 1.6),
    lineHeight: "18.79px",
    textTransform: "capitalize",
    backgroundColor: theme?.palette?.button?.buttonColor || "black",
    border: theme?.palette?.button?.buttonBorder ? "1px solid black" : null,
    // ...theme.typography.rockwell,
    "&:hover": {
      color: "#fff",
      backgroundColor: "black",
      cursor: "pointer",
    },
  },
}));

export default useStyles;
